export default {"src":"/_next/static/media/GetStarted.9703b54f.svg","height":352,"width":482};